export const handleJWTError = (err: any) => {
  if (err?.response?.data?.message === "missing or malformed jwt") {
    window.location.pathname = "/signin";
  }
};